import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ProviderGroupControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  providerGroupName?: string;
}

/**
 *
 * @author [Atish Bagate]
 */
export const useGetProviderDetailsByName = ({
  providerGroupName,
}: Props): useBaseContent<any> => {
  return useQuery({
    queryKey: [
      "provider-details-by-name",
      getXtenantId() ?? "",
      providerGroupName,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new ProviderGroupControllerApi(getConfigObject())
        .getProviderGroupDetail(
          providerGroupName!,
          getXtenantId() ?? "" // xTENANTID
        )
        .then((res) => res?.data),
  });
};
